import axios from 'axios';

window.axios = axios;
window.axios.defaults.baseURL = process.env.VUE_APP_API_ADMIN_LOCATION;
window.axios.defaults.headers.common.Accept = 'application/json';
window.axios.defaults.headers.common['Content-Type'] = 'application/json';
window.axios.defaults.headers.ignoreLoading = false;
